"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.starterLegacyConfig = void 0;
exports.starterLegacyConfig = {
    hasStarterLegacyUserRole: true,
    showAccountPayoutSettingsTab: true,
    showAccountSubscriptionTab: true,
    showRebrandGuideAndAssetsLink: true,
};
